/**
 * SEO utilities
 */

// Variable replacement (existing)
export { replaceSeoVariables, replaceUrlPlaceholders, type SeoVariables } from './seoVariables';

// Brand-specific constants
export { getSeoConstants, getBaseUrl, X_DEFAULT_LOCALE, type SeoConstants } from './constants';

// Canonical URL resolution
export { buildCanonicalUrl, buildCanonicalPath, type CanonicalOptions } from './canonical';

// PDP canonical from the designer-choice attribute
export {
  buildPdpCanonicalUrl,
  type PdpCanonicalOptions,
  type PdpCanonicalTarget,
} from './pdpCanonical';

// Hreflang generation
export {
  buildHreflangEntries,
  buildHreflangAlternates,
  countryCodesToPrimaryLocales,
  getPageHreflangAlternates,
  getPrimaryLocales,
  getSecondaryLocales,
  localeToBcp47,
  HREFLANG_COUNTRY_MAP,
  type HreflangEntry,
} from './hreflang';

// Structured data (JSON-LD)
export {
  buildWebSiteSchema,
  buildOrganizationSchema,
  buildBreadcrumbSchema,
  buildProductSchema,
  buildPdpProductJsonLd,
  mapCtaToSchemaAvailability,
  type JsonLdWebSite,
  type JsonLdOrganization,
  type JsonLdBreadcrumbList,
  type JsonLdBreadcrumbItem,
  type ProductAvailability,
  type BuildProductSchemaInput,
} from './structuredData';

// Metadata builder
export {
  buildPageMetadata,
  appendTitleSuffix,
  normalizeCmsCanonical,
  type PageMetadataOptions,
} from './metadata';

// Indexing rules
export { shouldIndex, buildRobotsMetadata, type IndexingOptions } from './indexingRules';

// JSON-LD component
export { JsonLd } from './JsonLd';
